import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { SettingsService } from '../../services/settings.service';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { NexusFormResultModel } from 'app/core/models/nexus-form-result.model';
import { ChangePasswordModel } from 'app/models/change-password.model';
import { faTimesCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { MustMatch } from 'app/core/validators/must-match.validator';
import { PasswordStrengthValidator } from 'app/core/validators/password-strengh.validator';

@Component({
    selector: 'app-security',
    templateUrl: './security.component.html',
    styleUrls: ['./security.component.scss'],
    standalone: false
})
export class SecurityComponent extends NexusComponent implements OnInit {
  // Font Awesome Icons
  faTimesCircle = faTimesCircle;
  faCheckCircle = faCheckCircle;

  // Models
  public change_password: ChangePasswordModel = new ChangePasswordModel();
  public password_result_model: NexusFormResultModel = new NexusFormResultModel();

  // Form
  public password_form: UntypedFormGroup;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private settings_service: SettingsService,
    private formBuilder: UntypedFormBuilder
  ) {
    super();
  }

  ngOnInit(): void {
    // Initialize password form with validators
    this.password_form = this.formBuilder.group({
      current_password: new UntypedFormControl('', Validators.required),
      new_password: ['', [Validators.required, PasswordStrengthValidator()]],
      confirm_password: ['', Validators.required]
    },
    {
      validator: MustMatch('new_password', 'confirm_password')
    });

    // Subscribe to form value changes
    this.password_form.valueChanges.subscribe((form: any) => {
      this.PopulateModelFromForm(form, this.change_password);
    });
  }

  // Getter to show password errors
  get showPasswordErrors() {
    if (this.password_form?.controls?.new_password?.errors?.required === true) {
      return false;
    }
    return !(this.password_form?.controls?.new_password?.errors == null);
  }

  // Getter for password validation errors
  get passwordErrors() {
    return this.password_form?.controls?.new_password.errors?.password_strength || {};
  }

  // Getter for confirm password validation
  get confirmPasswordErrors() {
    return (this.password_form?.controls?.confirm_password?.errors == null);
  }

  // Getter to show confirm password errors
  get showConfirmPasswordErrors() {
    return !this.password_form?.controls?.confirm_password?.errors?.required;
  }

  // Change password method
  changePassword(event: Event): void {
    event.preventDefault();

    if (this.password_form.invalid) {
      this.password_result_model.Incomplete();
      return;
    }

    this.password_result_model.Reset();
    this.StartSpinner();

    this.settings_service.ChangePassword(this.change_password).subscribe(
      data => {
        this.StopSpinner();
        this.password_result_model.Success('Password changed successfully!');
        this.password_form.reset();
      },
      err => {
        this.password_result_model.Error(err);
        this.StopSpinner();
      }
    );
  }
}
